import axios from '@/lib/axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface UpdateAddressPayload {
  address: string;
  city: string;
  state: string;
  zipcode: string;
  country: string;
  address_name: string;
  bedroom: number;
  bathroom: number;
  people: number;
  pet: number;
  cleaning_area: string;
  house_desc: string;
  default_address: boolean;
  latitude: number;
  longitude: number;
}

interface UpdateAddressParams {
  addressId: string;
  payload: UpdateAddressPayload;
}

const putUserUpdateAddressMutation = async ({
  addressId,
  payload,
}: UpdateAddressParams) => {
  const response = await axios.put(
    `/user/update_address/${addressId}/`,
    payload
  );
  return response;
};

export const usePutUserUpdateAddressMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['update-user-address'],
    mutationFn: putUserUpdateAddressMutation,
    onSuccess: () => {
      // Address book reads from ['user', 'details', userid]; prefix-match
      // invalidates all user-detail caches since userid is not available here.
      void queryClient.invalidateQueries({
        queryKey: ['user', 'details'],
        exact: false,
      });
    },
  });
};
